import {useCallback, useState} from 'react';
import {useCurrentRoute} from '~/CreateFabricInvitation/navigation';
import {UPSELL_MODES, UpsellModal} from '~/common/fabric/UpsellModal/UpsellModal';
import {useEventSave} from '~/OneStepCreateInvitation/hooks/useEventSave';
import {usePremiumFeatureBlocker} from '~/OneStepCreateInvitation/hooks/usePremiumFeatureBlocker';

export const useUpsellModal = (onExitCallback) => {
  const [showUpsellModal, setShowUpsellModal] = useState(false);
  const {isUsingPremiumFeature, confirmUpgrade} = usePremiumFeatureBlocker();
  const {autoSave} = useEventSave();

  const closeUpsellModal = useCallback(() => setShowUpsellModal(false), []);
  const toggleUpsellModal = useCallback(() => setShowUpsellModal((prev) => !prev), []);

  const currentRoute = useCurrentRoute();
  const isStep1 = currentRoute?.name === 'customize' && !currentRoute?.meta?.editing;

  const onConfirmUpsell = useCallback(async () => {
    confirmUpgrade();
    closeUpsellModal();
    await autoSave();
  }, [confirmUpgrade, closeUpsellModal, autoSave]);

  const renderUpsellModal = showUpsellModal
    ? <UpsellModal
        noAutoRestore
        toggleUpsellModal={toggleUpsellModal}
        closeOverlay={() => {
          closeUpsellModal();
          onExitCallback?.();
        }}
        onConfirmAction={onConfirmUpsell}
        openTray="customize"
        mode={isStep1 ? UPSELL_MODES.STEP_1_COPY : UPSELL_MODES.UNLOCK_DESIGN_TOOLS}
      />
    : null;

  return {
    showUpsellModal,
    toggleUpsellModal,
    closeUpsellModal,
    onConfirmUpsell,
    isUsingPremiumFeature,
    renderUpsellModal,
  };
};
